// import { createGlobalStyle } from 'styled-components';
import { Global, css } from '@emotion/react';
import { themeChakra } from '@wow/themes';
import React from 'react';

const {
  colors: { secondary },
  sizes,
  radii,
  textStyles,
} = themeChakra;

export interface StylesTooltip {
  stylesTooltipTitle?: string;
  stylesTooltipDesc?: string;
  stylesTooltip?: string;
}

interface CreateGlobalStyleProps {
  wizardID: string;
  placement: string;
  container: string;
  isModal: boolean;
  color?: string;
  bgColor?: string;
  stylesTooltip?: StylesTooltip;
  windowDimensions?: {height: number, width: number};
}

export const WizardTooltipPopupGlobalStyles: React.FC<CreateGlobalStyleProps> = ({
  wizardID,
  placement,
  container,
  isModal,
  color,
  bgColor,
  stylesTooltip
}) => (
  <Global
    styles={css`
      ${container} {
        overflow: auto;

        &:after {
          content: '';
          display: none;
        }
        & .wizard-${wizardID} {
          height: 0;
          overflow: hidden;
          & .tooltip-${wizardID} {
            position: fixed;
            visibility: hidden;
            opacity: 0;
            zindex: 0;
          }
        }
        &.wizard--active-${wizardID} {
          &::after {
            ${isModal ?  'display: block;' : 'display: none;'}
            ${isModal
              ? 'background-color: #2c2c2c6f;'
              : 'background-color: transparent;'}
            position: fixed;
            width: 100%;
            height: calc(100vh - 84px);
            left: 0;
            top: 0;
            overflow: hidden;
            cursor: not-allowed;
            z-index: ${!isModal ? 1 : 100};
          }

          & .wizard-${wizardID} {
            height: 0;
            overflow: auto;
            & .tooltip-${wizardID} {
              visibility: visible;
              opacity: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              background-color: ${bgColor || secondary[900]};
              padding: 16px;
              color: ${color || 'white'};
              text-align: left;
              border-radius: ${radii[8]};
              z-index: ${!isModal ? 1 : 102};
              &::after {
                content: '';
                display: block;
                width: 0;
                height: 0;
                border-style: solid;
                border-color: transparent transparent ${bgColor || secondary[900]}
                  transparent;
                position: absolute;
                ${placement === 'top' &&
                'border-width: 12px; top: -24px; left: 50%; transform: translateX(-50%);'}
                ${placement === 'top-start' &&
                'border-width: 12px; top: -24px; left: 10%; transform: translateX(-50%);'}
                ${placement === 'top-end' && 
                'border-width: 12px; top: -24px; left: 90%; transform: translateX(-50%);'}
                ${placement === 'bottom' &&
                'border-width: 12px; bottom: -24px; left: 50%; transform: translateX(-50%) rotate(-180deg);'}
                
                ${placement === 'bottom-start' &&
                'border-width: 12px; bottom: -20px; left: 10%; transform: translateX(-50%) rotate(-180deg);'}
                ${placement === 'bottom-end' &&
                'border-width: 12px; bottom: -20px; left: 90%; transform: translateX(-50%) rotate(-180deg);'}
                ${placement === 'right' &&
                'border-width: 12px; top: 50%; right: -24px; transform: translateY(-50%) rotate(90deg);'}
                ${placement === 'left' &&
                'border-width: 12px; top: 50%; left: -24px; transform: translateY(-50%) rotate(-90deg);'}
              }

              & .tooltip-header-title-${wizardID} {
                display: flex;
                justify-content: space-between;
                align-items: center;

                & p {
                  min-width: ${sizes[40]};
                  font-size: ${textStyles.titleSm.fontSize};
                  font-family: ${textStyles.titleSm.fontFamily};
                  font-weight: ${textStyles.titleSm.fontWeight};
                  line-height: ${textStyles.titleSm.lineHeight};
                  letter-spacing: ${textStyles.titleSm.letterSpacing};
                }
              }

              & .tooltip-body-${wizardID} {
                & .tooltip-body-title {
                  font-size: ${textStyles.titleMdBold.fontSize};
                  font-family: ${textStyles.titleMdBold.fontFamily};
                  font-weight: ${textStyles.titleMdBold.fontWeight};
                  line-height: ${textStyles.titleMdBold.lineHeight};
                  letter-spacing: ${textStyles.titleMdBold.letterSpacing};
                  ${stylesTooltip?.stylesTooltipTitle}
                }
                & .tooltip-body-desc {
                  font-size: ${textStyles.bodyMd.fontSize};
                  font-family: ${textStyles.bodyMd.fontFamily};
                  font-weight: ${textStyles.bodyMd.fontWeight};
                  line-height: ${textStyles.bodyMd.lineHeight};
                  letter-spacing: ${textStyles.bodyMd.letterSpacing};                 
                  ${stylesTooltip?.stylesTooltipDesc}
                }                
              }              
            }
          }

          & .wizard--focus-${wizardID} {
            z-index: ${isModal ? 1 : 101};
            pointer-events: none;
            transition: none;
            border-radius: ${radii[8]};
            cursor: auto;
          }

          & .wizard--focus-${wizardID}--white {
            background-color: white !important;
          }
        }
      }
    `}
  />
);
